<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

import { MinimalPackagingOrder, PackagingOrderStatus } from '@/types/packaging'

const { t } = useI18n()
const props = defineProps<{
    packagingOrder: MinimalPackagingOrder
}>()

const status = computed(() => {
    let color = 'bg-blue-400'
    let text = t('created')

    if (props.packagingOrder.status === PackagingOrderStatus.Accepted) {
        color = 'bg-yellow-400'
        text = t('accepted')
    } else if (props.packagingOrder.status === PackagingOrderStatus.Finished) {
        color = 'bg-green-500'
        text = t('finished')
    } else if (props.packagingOrder.status === PackagingOrderStatus.Canceled) {
        color = 'bg-red-500'
        text = t('canceled')
    }

    return { color, text }
})
</script>
<template>
    <div class="flex items-center">
        <div class="w-3 aspect-square mr-2 flex-shrink-0 rounded-full" :class="status.color" />
        <span v-text="status.text" />
    </div>
</template>
